import { useState } from 'react';
import { useAppState } from '../state/AppState';
import { BRANCHES } from '../domain/types';
import styles from './RmPicker.module.css';

/**
 * Prototype-only session picker. In production this becomes an OIDC sign-in
 * and the audit-trail `actor` is the authenticated principal — see ARCHITECTURE.
 */
export function RmPicker() {
  const { setRm } = useAppState();
  const [name, setName] = useState('');
  const [branch, setBranch] = useState<string>(BRANCHES[0]);
  const [error, setError] = useState<string | null>(null);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed.length < 2 || trimmed.length > 64) {
      setError('Enter your name (2–64 characters)');
      return;
    }
    setRm(`${trimmed} · ${branch}`);
  };

  return (
    <div className={styles.wrap}>
      <form className={styles.card} onSubmit={submit} aria-labelledby="rm-picker-heading">
        <h1 id="rm-picker-heading" className={styles.heading}>
          SENTINEL Onboarding
        </h1>
        <p className={styles.lead}>
          Identify yourself to start a session. Your name is recorded against every assessment
          you log.
        </p>

        <label className={styles.field}>
          <span className={styles.label}>Relationship manager</span>
          <input
            className={styles.input}
            type="text"
            autoComplete="name"
            inputMode="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={64}
            aria-invalid={error != null}
            aria-describedby={error ? 'rm-picker-error' : undefined}
            autoFocus
          />
        </label>

        <label className={styles.field}>
          <span className={styles.label}>Branch</span>
          <select
            className={styles.input}
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
          >
            {BRANCHES.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
          </select>
        </label>

        {error && (
          <div id="rm-picker-error" className={styles.errorText} role="alert">
            {error}
          </div>
        )}

        <button type="submit" className={styles.submit}>
          Start session
        </button>

        <p className={styles.note}>
          Prototype: replace with SSO/OIDC for production. The audit log records this name as
          the assessor.
        </p>
      </form>
    </div>
  );
}
